import { render, staticRenderFns } from "./_MarketNameModal.vue?vue&type=template&id=61d2e2f7&scoped=true&"
import script from "./_MarketNameModal.vue?vue&type=script&lang=js&"
export * from "./_MarketNameModal.vue?vue&type=script&lang=js&"
import style0 from "./_MarketNameModal.vue?vue&type=style&index=0&id=61d2e2f7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61d2e2f7",
  null
  
)

export default component.exports